import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useIsMobileView } from '../../utils/responsive';
import { hasSelectableNumbers } from '../../utils/raffleType';

import { Card, CardContent } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import MeliPayLogo from "../../assets/images/svg/mercadopago.png";
import PaypalLogo from "../../assets/images/svg/paypal.png";
import WebpayLogo from "../../assets/images/svg/webpay.png";
import { MobileTickets } from './tickets/mobileTickets';
import { PurchaseDialog } from '../payment/purchaseDialog';
import FormPayment from '../payment/form/payment';
import { IWinner } from '../../store/interfaces/IWinner';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/types/rootState';
import { SoldTicketsDashboardPublic } from '../soldTickets/soldTicketsPublic';
import { MobileTicketsV2 } from './tickets/mobileTicketsV2';


export interface Ticket {
  id: number;
  label: string;
}

const tickets: Ticket[] = [
  { id: 0, label: 'Ingresar tickets' },
  { id: 5, label: '5 TICKET' },
  { id: 10, label: '10 TICKETS' },
  { id: 20, label: '20 TICKETS' },
];


const paymentMethods = [
  {
    value: "transbank",
    label: "Webpay",
    icon: <img
      style={{
        height: "40px",
      }}
      src={WebpayLogo}
      alt=""
      key={'transbank'}
    />,
    info: "Será redirigido a webpay para finalizar su compra",
  },
  {
    value: "paypal",
    label: "Paypal",
    icon: <img
      style={{
        height: "40px",
      }}
      src={PaypalLogo}
      alt=""
      key={'paypal'}
    />,
    info: "-",
  },
  {
    value: "mercadopago",
    label: "Red Compra",
    icon: <img
      style={{
        height: "50px",
      }}
      src={MeliPayLogo}
      alt=""
      key={'mercadopago'}
    />,
    info: "-",
  },
];


interface RaffleTicketsProps {
  accountId: string;
  ticketPrice: number;
  ticketPriceUSD: number;
  availablePaymentMethods: string[];
  limit: number;
  raffleType: "promo" | "raffle" | "lottery" | "talonario";
  raffleId: string;
}

const RaffleTickets = ({ ticketPrice, ticketPriceUSD,  availablePaymentMethods, limit,  raffleId, raffleType, accountId }: RaffleTicketsProps) => {

  
  const isLoggedIn = useSelector(({ authentication }: RootState) => authentication.isLoggedIn);
  const accountInformation = useSelector(({ account }: RootState) => account);
  const [open, setOpen] = useState(true);
  const isMobile = useIsMobileView();
  const [selectedTickets, setSelectedTickets] = useState<number[] | undefined>();
  const [ticketQuantity, setTicketQuantity] = useState<number | null>(null);
  const [minPurchase, setMinPurchase] = useState<number>(limit === 100 || raffleType === 'promo' ? 1 : 2);
  const [desktopAdditions, setDesktopAdditions] = useState<number[]>([1]);
  const [additions, setAdditions] = useState<number[]>([1]);

  useEffect(() => {
      setDesktopAdditions([2, 10, 20, 50, 100])
      setAdditions([2, 10, 20, 50, 100])
  }, []);

  useEffect(() => {
    if (accountInformation.id === 'oscar-alarcon' || accountInformation.id === 'la-barberia' || accountInformation.id === 'victor-arteaga' || accountInformation.id === 'rifas-yoneell' || accountInformation.id == 'erick-gomez' || accountInformation.id === 'rifas-el' || accountInformation.id === 'moto-piruetas-vnz' || accountInformation.id === 'andrusth-barber' || accountInformation.id === 'gerej-16' || accountInformation.id === 'gana-con-alonso' || accountInformation.id === 'rifas-va' || accountInformation.id === 'gana-con-leonardo' || accountInformation.id === 'not-licencia-process' || accountInformation.id === 'rifas-yaracuy' || accountInformation.id === 'diego-merchan' || accountInformation.id === 'grita-caracas') {
      setMinPurchase(3)
      setDesktopAdditions([3, 10, 20, 50, 100])
      setAdditions([3, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'gana-con-los-compadres' ||accountInformation.id === 'rifas-23' || accountInformation.id === 'yilson-grau' || accountInformation.id === 'dilan-grau') {
      setMinPurchase(4)
      setDesktopAdditions([4, 10, 20, 50, 100])
      setAdditions([4, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'flow-exotico' ||  accountInformation.id === 'carlos-pinango' || accountInformation.id === 'jesuito-martinez') {
      setMinPurchase(5)
      setDesktopAdditions([5, 10, 15, 20, 25])
      setAdditions([5, 10, 15, 20, 25])
    }
    if (accountInformation.id === 'rifas-talca' || accountInformation.id === 'bendecidos-con-villa') {
      setMinPurchase(3)
      setDesktopAdditions([3, 5, 15, 30, 50])
      setAdditions([3, 5, 15, 30, 50])
    }
    if (accountInformation.id === 'gana-con-johnbi') {
      setMinPurchase(3)
      setDesktopAdditions([3, 6, 9, 12, 15])
      setAdditions([3, 6, 9, 12, 15])
    }
    if (accountInformation.id === 'rifa-loca') {
      setMinPurchase(4)
      setDesktopAdditions([4, 8, 12, 16, 20])
      setAdditions([4, 8, 12, 16, 20])
    }
    if (accountInformation.id === 'gana-con-salazar') {
      setMinPurchase(6)
      setDesktopAdditions([6, 10, 20, 50, 100])
      setAdditions([6, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'rifas-de-paquete') {
      setMinPurchase(2)
      setDesktopAdditions([2, 4, 6, 8, 10])
      setAdditions([2, 4, 6, 8, 10])
    }
    if (accountInformation.id === 'el-viejo') {
      setMinPurchase(10)
      setDesktopAdditions([10, 20, 50, 100])
      setAdditions([10, 20, 50, 100])
    }
    
    if (accountInformation.id === 'prueba-tu-suerte' || accountInformation.id === 'gana-con-ramon' || accountInformation.id === 'rifas-jose-miguel' || accountInformation.id === 'mono-lokura' ||  accountInformation.id === 'el-cartel-de-la-rifa' || accountInformation.id === 'aurora-graterol' || accountInformation.id === 'ultra-ganador' || accountInformation.id === 'la-guaira-market' || accountInformation.id === 'juega-y-gana-con-farfan' || accountInformation.id === 'rifas-el-gordo' || accountInformation.id === 'w-robles' || accountInformation.id === 'rifas-11-11' || accountInformation.id === 'exi-rifas' || accountInformation.id === 'la-buena-racha' || accountInformation.id === 'san-de-tu-suerte' || accountInformation.id === 'rifa-los-primos' || accountInformation.id === 'loto-family' || accountInformation.id === 'rifa-bera-2025' || accountInformation.id === 'wild-life-rescue' || accountInformation.id === 'johan-eventos' || accountInformation.id === 'juega-con-zapata' || accountInformation.id === 'rifas-petare' || accountInformation.id === 'gana-con-ibelles' ||  accountInformation.id === 'rifas-chente') {
      setMinPurchase(1)
      setDesktopAdditions([1, 3, 10, 20, 50])
      setAdditions([1, 3, 10, 20, 50])
    }
    

     if (raffleType === 'promo') {
      setMinPurchase(10)
      setDesktopAdditions([10])
      setAdditions([10])
    }
  }, []);


  const handleChangeQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let parsedValue: number | null = parseInt(value);
    const limitPurchase = raffleType === 'promo' ? 10 : limit === 10000 ? 100 : limit * 0.25;

    if (isNaN(parsedValue) || parsedValue < 0) {
      parsedValue = null;
    } else if (parsedValue > limitPurchase) {
      enqueueSnackbar(`El limite de compra para esta rifa es ${limitPurchase}!`, {
        variant: "error",
        anchorOrigin: {
          horizontal: "left",
          vertical: "top"
        },
      })
      parsedValue = limitPurchase;
    } else if (parsedValue < minPurchase) {
      enqueueSnackbar(`El mínimo de compra para la rifa es ${minPurchase}!`, {
        variant: "warning",
        anchorOrigin: {
          horizontal: "left",
          vertical: "top"
        },
      })
    }
    setTicketQuantity(parsedValue);
  };

  const sumTicketQuantity = (event: number) =>  {
    const limitPurchase = raffleType === 'promo' ? 10 : limit === 10000 ? 500 : limit * 0.25;
    if (ticketQuantity) {
      let parsedValue: number | null = ticketQuantity + event;
      if (isNaN(parsedValue) || parsedValue < 0) {
        parsedValue = null;
      } else if (parsedValue > limitPurchase) {
        enqueueSnackbar(`El limite de compra es ${limitPurchase}!`, {
          variant: "error",
          anchorOrigin: {
            horizontal: "left",
            vertical: "top"
          },
        })
        return
      }

      setTicketQuantity(ticketQuantity + event);
    } else {
      setTicketQuantity(event);
    }
  }

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
  React.useState<string | null>(null);
const [purchaserData, setPurchaserData] = React.useState<IWinner>({
  name: "",
  email: "",
  phone: "",
});

const handlePaymentMethodSelect = (method: string) => {
  setOpen(false)
  setSelectedPaymentMethod((prevMethod) =>
    prevMethod === method ? null : method
  );
};

const setTicketQuantityHandler = (ticketQuantity: number) => {
  setTicketQuantity(ticketQuantity);
}



  return (
    <Box paddingX={4}>
      {ticketQuantity && isLoggedIn && selectedPaymentMethod && <PurchaseDialog ticketQuantity={ticketQuantity} raffleId={raffleId} isMobile={isMobile} open={open} setOpen={setOpen} totalAmount={ticketQuantity * ticketPrice} totalAmountUSD={ticketQuantity * ticketPriceUSD}  availablePaymentMethods={availablePaymentMethods} />}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          { raffleType === 'raffle' ? <Grid container spacing={2}>
            {!isMobile ? (
              <>
              <Card sx={{
                width: '100%',
              }}>
                <CardContent>
                  <Box>
                    {accountId === 'agudojhonny' ? <MobileTicketsV2
                    additions={desktopAdditions}
                    handleChangeQuantity={handleChangeQuantity}
                    sumTicketQuantity={sumTicketQuantity}
                    ticketQuantity={ticketQuantity}
                    /> : <MobileTickets
                    additions={desktopAdditions}
                    handleChangeQuantity={handleChangeQuantity}
                    sumTicketQuantity={sumTicketQuantity}
                    ticketQuantity={ticketQuantity}
                    />}
                  </Box>
                </CardContent>
              </Card>
              </>
            ) : accountId === 'agudojhonny' ? <MobileTicketsV2
                additions={desktopAdditions}
                handleChangeQuantity={handleChangeQuantity}
                sumTicketQuantity={sumTicketQuantity}
                ticketQuantity={ticketQuantity}
                /> : <MobileTickets
                additions={desktopAdditions}
                handleChangeQuantity={handleChangeQuantity}
                sumTicketQuantity={sumTicketQuantity}
                ticketQuantity={ticketQuantity}
                />
            }
          </Grid> : hasSelectableNumbers(raffleType) ? <SoldTicketsDashboardPublic 
          limit={limit} 
          setTicketQuantity={setTicketQuantityHandler}
          setSelectedTickets={setSelectedTickets}
          ticketQuantity={ticketQuantity}
          raffleId={raffleId}
          ></SoldTicketsDashboardPublic> : <Card sx={{
            width: '100%',
          }}>
            <CardContent>
              <Box>
                <MobileTickets
                additions={desktopAdditions}
                handleChangeQuantity={handleChangeQuantity}
                sumTicketQuantity={sumTicketQuantity}
                ticketQuantity={ticketQuantity}
                />
              </Box>
            </CardContent>
          </Card>}
        </Grid>
        <Grid item xs={12} md={12}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection={"column"}
            paddingY={2}
            paddingTop={isMobile ? 1 : 6}
            width="100%"
          >
    
          
            {ticketQuantity && ticketQuantity > 0 && <Box p={2}> <Typography color={"primary"} variant='h5' fontWeight={"bold"}>
                  TOTAL: {`${(ticketQuantity || 0)} TICKET`}
            </Typography>
            </Box>}

            <FormPayment 
                minPurchase={minPurchase}
                selectedTickets={selectedTickets}
                availablePaymentMethods={availablePaymentMethods}
                handlePaymentMethodSelect={handlePaymentMethodSelect}
                purchaserData={purchaserData}
                raffleId={raffleId}
                selectedPaymentMethod={'transfer'}
                setOpen={setOpen}
                setPurchaserData={setPurchaserData}
                ticketQuantity={ticketQuantity || 0} 
                totalAmount={(ticketQuantity || 0) * ticketPrice} 
                totalAmountUSD={(ticketQuantity || 0) * ticketPriceUSD}
                />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RaffleTickets;
